import Immutable from 'immutable';

export default Immutable.fromJS({
    ready: {
        currentLabelTemplate: `Ready`,
        nextStateLabelTemplate: 'Ready',
        actionKey: 'setTechStatusReady',
        includeOrderId: false,
        allowedStates: [
            'enroute', 'onbreak', 'notready'
        ],
        icon: 'done'
    },
    notready: {
        currentLabelTemplate: `Not Ready`,
        nextStateLabelTemplate: `Set Not Ready`,
        actionKey: 'setTechStatusNotReady',
        includeOrderId: false,
        allowedStates: ['ready'],
        icon: 'not_interested'
    },
    undoenroute: {
        currentLabelTemplate: '',
        nextStateLabelTemplate: `Undo In Route`,
        actionKey: 'setTechStatusUndoInRoute',
        allowedStates: [],
        icon: 'undo'
    },
    undoonjob: {
        currentLabelTemplate: '',
        nextStateLabelTemplate: `Undo In Service`,
        actionKey: 'setTechStatusUndoOnJob',
        allowedStates: [],
        icon: 'undo'
    },
    enroute: {
        currentLabelTemplate: `In Route to firstWorkOrderNumber`,
        nextStateLabelTemplate: `Go In Route to firstWorkOrderNumber`,
        actionKey: 'showArrivalTimeDialog',
        includeOrderId: true,
        allowedStates: [
            'onjob', 'undoEnroute'
        ],
        icon: 'directions'
    },
    onjob: {
        currentLabelTemplate: `In Service - firstWorkOrderNumber`,
        nextStateLabelTemplate: `Set In Service - firstWorkOrderNumber`,
        actionKey: 'setTechStatusOnJob',
        includeOrderId: true,
        allowedStates: ['undoOnJob'],
        icon: 'build'
    },
    onbreak: {
        currentLabelTemplate: `On Break`,
        nextStateLabelTemplate: `Go On Break`,
        actionKey: 'setTechStatusOnBreak',
        includeOrderId: false,
        allowedStates: ['offbreak'],
        icon: 'restaurant_menu'
    },
    offbreak: {
        currentLabelTemplate: `Ready`,
        nextStateLabelTemplate: `Go Off Break`,
        actionKey: 'setTechStatusOffBreak',
        includeOrderId: false,
        allowedStates: [],
        icon: 'done'
    },
    none: {
        currentLabelTemplate: `Not Ready`,
        nextStateLabelTemplate: `Set Not Ready`,
        actionKey: '',
        includeOrderId: false,
        allowedStates: ['ready'],
        icon: 'not_interested'
    }
});


// WEBPACK FOOTER //
// ./src/status/statusConfigItem.js